import { useState } from "preact/hooks";
import type { Ctx } from "../app";
import { must, sb } from "../lib/supabase";
import { Badge, Card, ErrorBox, Loading, daysUntil, fmtDate, formData, useAction, useLoad } from "../lib/ui";

export function TasksPage({ ctx }: { ctx: Ctx }) {
  const [showDone, setShowDone] = useState(false);
  const [mine, setMine] = useState(false);
  const { busy, run } = useAction();
  const { data, error, reload } = useLoad(async () => {
    let q = sb().from("tasks").select("*, providers(first_name, last_name)").eq("org_id", ctx.orgId).order("due_on").limit(500);
    if (!showDone) q = q.is("done_at", null);
    if (mine) q = q.eq("assignee", ctx.userId);
    return must(await q) as any[];
  }, [ctx.orgId, showDone, mine]);

  if (error) return <ErrorBox error={error} />;
  if (!data) return <Loading />;
  const ro = ctx.role === "viewer";
  return (
    <Card title="Tasks & reminders" actions={<>
      <label class="inline"><input type="checkbox" checked={mine} onChange={(e) => setMine(e.currentTarget.checked)} /> Assigned to me</label>
      <label class="inline"><input type="checkbox" checked={showDone} onChange={(e) => setShowDone(e.currentTarget.checked)} /> Show done</label>
    </>}>
      {!ro && <form class="row" onSubmit={(e) => {
        const f = formData(e);
        const form = e.currentTarget as HTMLFormElement;
        run(async () => { must(await sb().from("tasks").insert({ org_id: ctx.orgId, kind: "manual", title: f.title, due_on: f.due_on })); form.reset(); reload(); }, "Task added");
      }}>
        <input name="title" required placeholder="New task" class="grow" />
        <input name="due_on" type="date" required value={new Date().toISOString().slice(0, 10)} />
        <button disabled={busy}>Add</button>
      </form>}
      {data.length === 0 ? <p class="muted">Nothing to do.</p> : (
        <table>
          <thead><tr><th>Due</th><th>Task</th><th>Type</th><th></th></tr></thead>
          <tbody>{data.map((t) => {
            const d = daysUntil(t.due_on);
            return (
              <tr class={t.done_at ? "done" : ""}>
                <td><span class={`badge ${t.done_at ? "" : d < 0 ? "bad" : d <= 7 ? "warn" : ""}`}>{fmtDate(t.due_on)}</span></td>
                <td>{t.title}
                  {t.application_id && <> · <a href={`#/applications/${t.application_id}`}>application</a></>}
                  {t.provider_id && !t.application_id && <> · <a href={`#/providers/${t.provider_id}`}>BCBA</a></>}</td>
                <td><Badge value={t.kind} /></td>
                <td>{!ro && (t.done_at
                  ? <button class="small ghost" disabled={busy} onClick={() => run(async () => { must(await sb().from("tasks").update({ done_at: null, done_by: null }).eq("id", t.id)); reload(); })}>Reopen</button>
                  : <button class="small" disabled={busy} onClick={() => run(async () => { must(await sb().from("tasks").update({ done_at: new Date().toISOString(), done_by: ctx.userId }).eq("id", t.id)); reload(); }, "Done")}>Done</button>)}</td>
              </tr>);
          })}</tbody>
        </table>
      )}
    </Card>
  );
}
